export const env = {
    production: false,
}
